type PinMarkProps = {
  size?: number;
  className?: string;
};

/** The one motif: a pushpin. Marks the brand, an empty state and, from WP-R2, today's column. */
export function PinMark({ size = 22, className = '' }: PinMarkProps) {
  return (
    <svg data-mark="pin" aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" className={className}>
      {/* head */}
      <circle cx="12" cy="9" r="7" fill="var(--accent)" />
      {/* highlight */}
      <circle cx="9.5" cy="6.5" r="2" fill="var(--on-accent)" opacity="0.7" />
      {/* needle */}
      <path d="M12 16v6" stroke="var(--text)" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
